import {Attachment} from '../../../allkey/framework/message/Attachment';
import {BasicBatchWrapper} from './BasicBatchWrapper';
import {UploadItem} from './UploadItem';

export class MassUploadWrapper extends BasicBatchWrapper {
attachments: Attachment[];
directory: string;
files: UploadItem[];
}

